import $ from "jquery";
import "slick-carousel/slick/slick";
import { LessonTestApi } from "./LessonTest.api";
import { t } from "i18next";
import {LessonApi} from "../Lesson.api";

export class LessonTestFunctions {
  static processData(data, globalState) {
    globalState.setTest(data.tests);
    globalState.setUnit(data.units);

    let slides = globalState.slides;
    let links = globalState.links;
    let exercises = globalState.exercises;
    let rubrics = globalState.rubrics;
    let corrections = globalState.corrections;
    let finalCorrection = globalState.finalCorrection;

    if (globalState.test.rubricsCollection != null) {
      for (const rubric of globalState.test.rubricsCollection.items) {
        rubrics.push(rubric);
      }
    }

    if (globalState.test.testBlocksCollection != null) {
      let slidePosition = 0;

      function addInitialSlideNote(slidePosition) {
        let slide = {
          info: {
            slug: "general-information",
            title: t("general.information"),
          },
          slidePosition: slidePosition,
          globalState: globalState,
        };

        let link = {
          info: {
            slug: "general-information",
            title: slide.info.title,
          },
          slidePosition: slidePosition,
          globalState: globalState,
        };

        slides.push(slide);
        links.push(link);
      }

      if (
        globalState.mode !== "reviewed" &&
        !slides.find((s) => s.info.slug === "general-information")
      ) {
        addInitialSlideNote.call(this, slidePosition);
        slidePosition++;
      }

      function addReviewedSlideNote(slidePosition) {
        let slide = {
          info: {
            slug: "reviewed",
            title: t("review"),
          },
          slidePosition: slidePosition,
          globalState: globalState,
        };

        let link = {
          info: {
            slug: "reviewed",
            title: slide.info.title,
          },
          slidePosition: slidePosition,
          globalState: globalState,
        };

        slides.push(slide);
        links.push(link);
      }

      if (
        globalState.mode === "reviewed" &&
        !slides.find((s) => s.info.slug === "reviewed")
      ) {
        addReviewedSlideNote.call(this, slidePosition);
        slidePosition++;
      }

      let exercisePosition = 1;
      for (const testBlock of globalState.test.testBlocksCollection?.items.filter(item => item != null)) {
        let answerResult = globalState.apiInfo?.params?.answers != null ?
            globalState.apiInfo.params.answers.results.answers.find(a => a.exerciseBlock_id == testBlock.sys.id)
            : null;

        let exerciseInfo = {
          exerciseBlock: testBlock,
          position: exercisePosition,
          slidePosition: slidePosition,
          results: answerResult
            ? answerResult
            : {
                exerciseBlock_id: testBlock.sys.id,
                digitalTemplate: testBlock.digitalTemplate,
                correctAnswer: ``,
                answers: ``,
                // competency: teachingBlockRubric?.evaluationItem?.competence?.sys.id,
                level: 1,
                score: 0,
                correct: false,
                answered: false,
              },
        };

        let slide = {
          info: {
            slug: `${testBlock.sys.id}`,
            title: `${t("ejercicio")} ${slidePosition}`,
          },
          exerciseInfo: exerciseInfo,
          slidePosition: slidePosition,
          globalState: globalState,
        };

        let link = {
          info: {
            slug: `${testBlock.sys.id}`,
            title: `${t("ejercicio")} ${slidePosition}`,
          },
          slidePosition: slidePosition,
          globalState: globalState,
        };

        exercises.push(exerciseInfo);
        slides.push(slide);
        links.push(link);

        let answerCorrection = globalState.apiInfo?.params?.corrections != null ?
            globalState.apiInfo.params.corrections.find(a => a.exerciseBlock_id == testBlock.sys.id)
            : null;

        let correctionScore = answerCorrection && answerCorrection.corrected
            ? answerCorrection.score
            : (answerResult ? answerResult.score : 0);

        let correction = {
              exerciseBlock_id: testBlock.sys.id,
              competency: "" /*teachingBlockRubric?.evaluationItem?.competence?.sys.id*/,
              level: LessonTestFunctions.getLevelFromScore(correctionScore),
              score: correctionScore,
              correct: LessonTestFunctions.IsCorrectFromScore(correctionScore),
              feedback: answerCorrection?.feedback ?? "",
              corrected: answerCorrection?.corrected ?? false,
              answered: answerResult?.answered ?? false
            };

        corrections.push(correction);

        slidePosition++;
        exercisePosition++;
      }

      finalCorrection = {
        score: globalState.apiInfo?.params?.score
          ? globalState.apiInfo.params.score
          : 0,
        competencies: globalState.apiInfo?.params?.competence_level
          ? globalState.apiInfo.params.competence_level
          : [],
        feedback: globalState.apiInfo?.params?.feedback
          ? globalState.apiInfo.params.feedback
          : "",
      };

      for (let rubric of rubrics) {
        if (
          !finalCorrection.competencies.find(
            (c) => c.competency == rubric.evaluationItem?.competence?.sys.id
          )
        ) {
          finalCorrection.competencies.push({
            competency: rubric.evaluationItem?.competence?.sys.id,
            level: 1,
          });
        }
      }

      function addSummarySlideNote(slidePosition) {
        let slide = {
          info: {
            slug: "summary",
            title: t("summary"),
          },
          exercises: globalState.exercises,
          slidePosition: slidePosition,
          globalState: globalState,
        };

        let link = {
          info: {
            slug: "summary",
            title: slide.info.title,
          },
          slidePosition: slidePosition,
          globalState: globalState,
        };

        slides.push(slide);
        links.push(link);
      }

      if (!slides.find((s) => s.info.slug === "summary")) {
        addSummarySlideNote.call(this, slidePosition);
        slidePosition++;
      }

      function addDeliveredSlideNote(slidePosition) {
        let slide = {
          info: {
            slug: "delivered",
            title: t("delivered"),
          },
          slidePosition: slidePosition,
          globalState: globalState,
        };

        let link = {
          info: {
            slug: "delivered",
            title: slide.info.title,
          },
          slidePosition: slidePosition,
          globalState: globalState,
        };

        slides.push(slide);
        links.push(link);
      }

      if (
        globalState.mode === "delivered" &&
        !slides.find((s) => s.info.slug === "delivered")
      ) {
        addDeliveredSlideNote.call(this, slidePosition);
        slidePosition++;
      }

      function addWaitingSlideNote(slidePosition) {
        let slide = {
          info: {
            slug: "waiting",
            title: "Waiting room",
          },
          slidePosition: slidePosition,
          globalState: globalState,
        };

        let link = {
          info: {
            slug: "waiting",
            title: slide.info.title,
          },
          slidePosition: slidePosition,
          globalState: globalState,
        };

        slides.push(slide);
        links.push(link);
      }

      if (
        globalState.mode === "waiting" &&
        !slides.find((s) => s.info.slug === "waiting")
      ) {
        addWaitingSlideNote.call(this, slidePosition);
        slidePosition++;
      }
    }

    globalState.setSlides(slides);
    globalState.setLinks(links);
    globalState.setExercises(exercises);
    globalState.setRubrics(rubrics);
    globalState.setCorrections(corrections);
    globalState.setFinalCorrection(finalCorrection);
  }

  static reprocessExercises(globalState, apiInfo) {
    if (apiInfo) {
      let exercises = globalState.exercises;

      for (const exercise of exercises) {
        exercise.results =
          apiInfo.params.answers.results.answers[exercise.slidePosition - 1];
      }

      globalState.setExercises(exercises);
    }
  }

  static reprocessCorrections(globalState, apiInfo) {
    if (apiInfo) {
      let corrections = globalState.corrections;

      for (const [i, correction] of corrections) {
        correction.score = apiInfo.params.corrections[i].score;
        correction.feedback = apiInfo.params.corrections[i].feedback;
        correction.level = apiInfo.params.corrections[i].level;
        correction.correct = apiInfo.params.corrections[i].correct;
        correction.corrected = apiInfo.params.corrections[i].corrected;
        correction.answered = apiInfo.params.corrections[i].answered;
      }

      globalState.setCorrections(corrections);

      let finalCorrection = globalState.finalCorrection;

      finalCorrection.score = apiInfo.params.score;
      finalCorrection.feedback = apiInfo.params.feedback;

      globalState.setFinalCorrection(finalCorrection);
    }
  }

  static calculateResults(globalState, exercises) {
    let results = [];

    for (let rubric of globalState.rubrics) {
      if (rubric.evaluationItem?.competence) {
        let result = {
          rubric_id: rubric.sys.id,
          rubric_name: rubric.idName,
          competence_id: rubric.evaluationItem.competence.sys.id,
          quantitative: 0,
          qualitative: "",
        };

        let rubricExercises = exercises.filter(
          (e) => e.rubric?.sys.id === result.rubric_id
        );
        for (let exercise of rubricExercises) {
          result.quantitative += exercise.results.answered
            ? exercise.results.score ?? 0
            : 0;
        }

        result.quantitative = (
          result.quantitative / rubricExercises.length
        ).toFixed(2);

        if (result.quantitative <= 4) result.qualitative = "N1";
        else if (result.quantitative <= 6) result.qualitative = "N2";
        else if (result.quantitative <= 8) result.qualitative = "N3";
        else result.qualitative = "N4";

        results.push(result);
      }
    }

    globalState.setResults(results);
  }

  static toggleFullscreen() {
    let elem = document.documentElement;

    if (document.fullscreenElement) {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    } else {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      }
    }
  }

  static sendTest(globalState) {
    globalState.setPopup("sendTest");
  }

  static startTest(globalState) {
    let location = `${globalState.props.location.pathname}?type=started`;

    if (globalState.authToken)
      location += `&auth_token=${globalState.authToken}`;

    if (globalState.role) location += `&role=${globalState.role}`;

    if (globalState.studentId) location += `&uuid=${globalState.studentId}`;

    if (globalState.devMode) location += "&devMode=true";

    if (globalState.teacherMode) location += "&teacherMode=true";

    if (globalState.channel) location += `&channel=${globalState.channel}`;

    window.location.replace(location);
  }

  static closeTest(globalState) {
    LessonTestApi.sendTest(globalState);
  }

  static retryExercise(state) {
    state.currentSlidePosition = 0;
    $(".slideNotes").slick("slickGoTo", state.currentSlidePosition, false);
  }

  static goToSlide(e, state) {
    state.currentSlidePosition = $(e.currentTarget).data("slide");
    $(".slideNotes").slick("slickGoTo", state.currentSlidePosition, false);
  }

  static initSlickCarousel(globalState) {
    let elements = document.getElementsByClassName("slideNotes");

    let shouldInitCarousel =
      !globalState.isSlickCreated &&
      elements !== null &&
      elements.length !== 0 &&
      globalState.mode !== "loading" &&
      globalState.mode !== "blocked";

    if (shouldInitCarousel) {
      $(".slideNotes").on("init", function (event, slick) {});

      let slick = $(".slideNotes").slick({
        infinite: false,
        prevArrow: ".leftArrow",
        nextArrow: ".rightArrow",
        touchThreshold: 20,
        draggable: false,
      });

      if (slick) {
        globalState.setIsSlickCreated(true);
      }

      $(".slideNotes").on(
        "beforeChange",
        function (event, slick, currentSlide, nextSlide) {
          globalState.setXapiStatement({verb: "left", slidePosition: currentSlide +1});
          globalState.setCurrentSlidePosition(nextSlide + 1);
        }
      );

      // $(document).keydown(function (event) {
      //   if (event.which === 39) {
      //     if (
      //       globalState.currentSlidePosition !==
      //       globalState.slides.length - 1
      //     )
      //       $(".slideNotes").slick("slickNext");
      //   }
      //   if (event.which === 37) {
      //     $(".slideNotes").slick("slickPrev");
      //   }
      // });
    }
  }

  static getMode(globalState, apiInfo) {
    // let possibleModes = ['loading', 'blocked', 'solve_first_time', 'solve_retry', 'display_with_data', 'display_without_data', 'correct']

    if (globalState) {
      switch (globalState.role) {
        case "student":
          switch (globalState.type) {
            case "blocked":
              globalState.setStatusBanner('outDeadline');
              return "blocked";
            case "display":
              return apiInfo?.params?.answers == null
                ? "display_without_data"
                : "display_with_data";
            case "opened":
              globalState.setStatusBanner('inactiveTest');
              return "blocked";
            case "started":
              if(apiInfo?.params?.type == "delivered"){
                LessonApi.redirectToMode(globalState, 'blocked')
                return "blocked";
              }else{
                return apiInfo?.params?.answers == null
                    ? "solve_first_time"
                    : "solve_continue";
              }
            case "in-progress":
              return "solve_continue";
            case "delivered":
              if(globalState.justFinished){
                return "delivered";
              }else{
                globalState.setStatusBanner('waitingTeacherCorrection');
                return "blocked";
              }
            case "reviewed":
              return "reviewed";
            case "closed":
              return "delivered";
            default:
              return "loading";
          }
        case "teacher":
          switch (globalState.type) {
            case "display":
              return "display_without_data";
            case "in-review":
              return apiInfo?.params?.corrections == null
                  ? "in_review_first_time"
                  : "in_review_continue";
            case "delivered":
            case "reviewed":
              return "reviewed";
            default:
              return "loading";
          }
        case "admin":
          switch (globalState.type) {
            case "display":
              return "display_without_data";
            case "corrected":
              return "corrected";
            default:
              return "loading";
          }
        default:
          return "loading";
      }
    } else {
      return "loading";
    }
  }

  static getLevelFromScore(score = 0) {
    if (score <= 4) return 1;
    else if (score <= 6) return 2;
    else if (score <= 8) return 3;
    else return 4;
  }

  static IsCorrectFromScore(score = 0) {
    return score >= 5;
  }
}
